import { UIIcon } from "@dropbox/dig-icons";
import { Twinkle2Line } from "@dropbox/dig-icons/assets";
import { useShowOmniboxAskTooltip } from "@mirage/mosaics/Omnibox/hooks/useShowOmniboxAskTooltip";
import { typeahead } from "@mirage/service-typeahead-search/service/types";
import { useEffect, useRef } from "react";
import { AskQueryTooltip } from "../AskQueryTooltip";
import { BaseResultRow } from "./BaseResultRow";

export const CurrentAskQueryResultRow = ({
  title,
  subtitle,
}: {
  isSelected: boolean;
  title: string;
  subtitle: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { shouldShowTooltip, setHasSeenOmniboxAskTooltip } =
    useShowOmniboxAskTooltip(typeahead.ResultType.AskUserQuery);

  useEffect(() => {
    return () => {
      // We set hide tooltip on unmount to ensure we don't show it again
      if (shouldShowTooltip) {
        setHasSeenOmniboxAskTooltip();
      }
    };
  }, [shouldShowTooltip, setHasSeenOmniboxAskTooltip]);

  const icon = (
    <UIIcon src={Twinkle2Line} color={"var(--dig-color__text__base)"} />
  );

  return (
    <>
      <BaseResultRow
        icon={icon}
        title={title}
        subtitle={subtitle}
        // Not using highlightWords to avoid unnecessary processing
        titleAlwaysBold
        ref={ref}
      />
      {shouldShowTooltip && (
        <AskQueryTooltip
          triggerRef={ref}
          placement="left"
          onDismiss={setHasSeenOmniboxAskTooltip}
        />
      )}
    </>
  );
};
CurrentAskQueryResultRow.displayName = "CurrentAskQueryResultRow";
